/**
 * Applies route-based SEO whenever the location changes.
 * Mount once inside BrowserRouter.
 */
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { resolvePageSeo } from './seoConfig';
import { applyPageSeo } from './usePageSeo';

export function SeoRoute() {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = resolvePageSeo(pathname);
    applyPageSeo(page);
  }, [pathname]);

  return null;
}

export default SeoRoute;
